import { computed, observable } from 'mobx';

export type OrganizationBaseResponseArgs = {
  id: number;
  name: string;
  organization_id: number;
  address: string;
  postal_code: string;
  addressee: string;
  google_map_address?: string;
};

export type OrganizationBaseArgs = {
  id: number;
  name: string;
  organizationId: number;
  address: string;
  postalCode: string;
  addressee: string;
  googleMapAddress?: string;
};

export const convertOrganizationBaseResponseToArgs = (response: OrganizationBaseResponseArgs) => {
  const args: OrganizationBaseArgs = {
    id: response.id,
    name: response.name,
    organizationId: response.organization_id,
    address: response.address,
    postalCode: response.postal_code,
    addressee: response.addressee,
    googleMapAddress: response.google_map_address
  };
  return args;
};

export default class OrganizationBase {
  @observable id: number;
  @observable name: string;
  @observable organizationId: number;
  @observable address: string;
  @observable postalCode: string;
  @observable addressee: string;
  @observable googleMapAddress?: string;

  constructor(args: OrganizationBaseArgs) {
    this.id = args.id;
    this.name = args.name;
    this.organizationId = args.organizationId;
    this.address = args.address;
    this.postalCode = args.postalCode;
    this.addressee = args.addressee;
    this.googleMapAddress = args.googleMapAddress;
  }

  @computed get description(): string {
    if (!this.address) return `${this.name}：住所が登録されていません`;
    return `${this.name}：${this.postalCode || ''} ${this.address} ${this.addressee || ''}`;
  }
}
